var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.teacher && _vm.onlineOnly
        ? _c("div", { staticClass: "soli-grey flex justify-center" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  `${_vm.teacher.first_name} is only available for online lessons`
                ) +
                "\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-list",
        [
          _c(
            "v-list-item",
            [
              _c("SoliAvatarBtn", {
                attrs: {
                  title: "In-Studio",
                  icon: "storefront",
                  blue: "",
                  disabled: _vm.onlineOnly,
                  subtitleBottom: _vm.location?.name,
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("input", false)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item",
            [
              _c("SoliAvatarBtn", {
                attrs: {
                  title: "Online",
                  icon: "videocam",
                  blue: "",
                  subtitleBottom: "Zoom or Google Meet",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("input", true)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }